import * as actions from './actions';

import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import { TeamMember } from '@services/teams/types/team-member';
import { NewTeamMember } from '@services/teams/types/new-team-member';

export class GetTeamMembers implements LoadingAction {
  readonly type = actions.GET_TEAM_MEMBERS;
  readonly isLoading = true;

  constructor(public labelId: string) {}
}

export class GetTeamMembersSuccess implements LoadingAction {
  readonly type = actions.GET_TEAM_MEMBERS_SUCCESS;
  readonly isLoading = false;

  constructor(public members: TeamMember[]) {}
}

export class GetTeamMembersError implements ErrorAction {
  readonly type = actions.GET_TEAM_MEMBERS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateTeamMember implements LoadingAction {
  readonly type = actions.UPDATE_TEAM_MEMBER;
  readonly isLoading = true;

  constructor(public member: TeamMember) {}
}

export class UpdateTeamMemberSuccess implements LoadingAction {
  readonly type = actions.UPDATE_TEAM_MEMBER_SUCCESS;
  readonly isLoading = false;

  constructor(public member: TeamMember) {}
}

export class UpdateTeamMemberError implements ErrorAction {
  readonly type = actions.UPDATE_TEAM_MEMBER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateTeamMember implements LoadingAction {
  readonly type = actions.CREATE_TEAM_MEMBER;
  readonly isLoading = true;

  constructor(public member: NewTeamMember) {}
}

export class CreateTeamMemberSuccess implements LoadingAction {
  readonly type = actions.CREATE_TEAM_MEMBER_SUCCESS;
  readonly isLoading = false;

  constructor(public member: TeamMember) {}
}

export class CreateTeamMemberError implements ErrorAction {
  readonly type = actions.CREATE_TEAM_MEMBER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RemoveTeamMember implements LoadingAction {
  readonly type = actions.REMOVE_TEAM_MEMBER;
  readonly isLoading = true;

  constructor(public member: TeamMember) {}
}

export class RemoveTeamMemberSuccess implements LoadingAction {
  readonly type = actions.REMOVE_TEAM_MEMBER_SUCCESS;
  readonly isLoading = false;

  constructor(public member: TeamMember) {}
}

export class RemoveTeamMemberError implements ErrorAction {
  readonly type = actions.REMOVE_TEAM_MEMBER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type TeamsActions =
  | GetTeamMembers
  | GetTeamMembersSuccess
  | GetTeamMembersError
  | UpdateTeamMember
  | UpdateTeamMemberSuccess
  | UpdateTeamMemberError
  | CreateTeamMember
  | CreateTeamMemberSuccess
  | CreateTeamMemberError
  | RemoveTeamMember
  | RemoveTeamMemberSuccess
  | RemoveTeamMemberError;
